// extracted by mini-css-extract-plugin
export default {"form__content":"form_form__content__LZGBP"};